<template>
  <button class="btn" :class="cssType + ' ' + props.type + ' ' + (props.disabled ? 'disabled' : '') + ' ' + locale + ' ' + props.size">
    <span class="btn-inner">
      <slot></slot>
    </span>
  </button>
</template>
<script setup>
import { defineProps } from 'vue'
import { isMobile } from '@/utils'
import { useI18n } from 'vue-i18n'
const { locale } = useI18n()
const cssType = isMobile ? 'mobile' : 'pc'
const props = defineProps({
  type: {
    type: String,
    default: 'white', // white yellow red red2
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: 'default', // default small
  },
})
</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>